import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/translation.json";
import ar from "./locales/ar/translation.json";

const resources = {
    en: { translation: en },
    ar: { translation: ar },
};

i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});

// Update document direction and lang when language changes
if (typeof document !== "undefined") {
    const applyDirection = (lng) => {
        const dir = lng === "ar" ? "rtl" : "ltr";
        document.documentElement.dir = dir;
        document.documentElement.lang = lng;
    };

    applyDirection(i18n.language);

    i18n.on("languageChanged", (lng) => {
        applyDirection(lng);
    });
}

export default i18n;

